import { createAuthInstance, createXSRFInstance } from 'axios-interceptor'

export default {
  namespaced: true,

  state: {
    attestedReqs: []
  },

  mutations: {
    setAttestedReqs (state, attestedReqs) {
      state.attestedReqs = attestedReqs
    }
  },

  getters: {
    hasAHA (state) {
      // Returns true if any attestedReq has aha_certification set to true
      return state.attestedReqs.some((req) => req.aha_certification)
    },

    otherCertifications (state) {
      // Builds an aggregate list of all other_certifications from all attestedReqs
      // Should prevent duplicates
      const certs = []

      for (const req of state.attestedReqs) {
        for (const cert of req.other_certifications) {
          if (!certs.includes(cert)) {
            certs.push(cert)
          }
        }
      }

      return certs
    }
  },

  actions: {
    getAttestedReqs (context, providerId) {
      const axios = createAuthInstance(context, createXSRFInstance())
      return axios({
        method: 'get',
        url: `/api/v2/providers/${providerId}/attested_reqirements`
      }).then(({ data }) => {
        context.commit('setAttestedReqs', data.data.attested_reqs)
      })
    }
  }
}
